import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import InstagramBotCard from '../../components/instagram/InstagramBotCard'
// import { IBotApplication } from '../../utils/interfaces/IBotApplication'

const AllInstagram = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [allBots, setAllBots] = useState<any[]>([])

  const fetchAllBots = async () => {
    try {
      setIsLoading(true)
      const token = localStorage.getItem('auth-token')

      const response = await fetch(
        `${process.env.REACT_APP_RESUME_PARSER_URL}/getAllInstagramApplication`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      )

      if (!response.ok) throw new Error('Failed to fetch WhatsApp bots')

      const data = await response.json()
      // Ensure data is an array before setting state
      setAllBots(Array.isArray(data) ? data : [])
    } catch (error) {
      console.error('Error fetching WhatsApp bots:', error)
      setAllBots([]) // Set to empty array on error
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchAllBots()
  }, [])

  return (
    <>
      <style>{`
        .instagram-card {
            background-color: #fff;
            padding: 1rem 1.5rem;
            border-top-left-radius: 12px;
             border-top-right-radius: 12px;
            margin-bottom: 0.5rem;
            box-shadow: 0 4px 12px rgba(0,0,0,0.04);
          }

        .templates-container {
            background-color: #ffffff;
            padding: 2rem;
            border-bottom-left-radius: 12px;
            border-bottom-right-radius: 12px;
            box-shadow: 0 8px 30px rgba(0,0,0,0.06);
          }

      `}</style>
      <div style={{ backgroundColor: '#FBF9FF', padding: '2rem 2rem', minHeight: '100vh' }}>
        {/* Header */}
        <div className='instagram-card'>
          <div className='d-flex justify-content-between align-items-center mb-5'>
            <div>
              <h1 className='fw-bolder text-dark mb-0'>All Instagram Bots</h1>
              <p className='text-muted fs-6 mb-0'>{allBots.length} Bot</p>
            </div>
            <Link
              to='/instagram-bots/create-new-instagram-bot'
              className='btn fw-bolder d-flex align-items-center'
              style={{
                backgroundColor: '#8A3FFC',
                color: 'white',
                padding: '0.75rem 1.5rem',
                borderRadius: '0.5rem'
              }}
            >
              {<i className='bi bi-plus fs-1 text-white me-2' />}
              Create Bot
            </Link>
          </div>
        </div>

        {/* Bots List */}
        <div className='templates-container d-flex flex-column gap-4'>
          {isLoading ? (
            <div className='d-flex justify-content-center align-items-center py-5'>
              <div className='spinner-border text-primary'>
                <span className='visually-hidden'>Loading...</span>
              </div>
            </div>
          ) : allBots.length > 0 ? (
            // Reverse the array for newest-first order
            [...allBots].reverse().map((bot: any, index: number) => (
              <InstagramBotCard
                // key={bot.whatsAppIDString}
                bot={bot}
                index={index}
                setIsLoading={setIsLoading}
                fetchAllBots={fetchAllBots}
              />
            ))
          ) : (
            <div className='card p-5 text-center text-muted'>
              <p className='mb-0'>No bots found. Get started by creating one!</p>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default AllInstagram
